
import React from 'react';
import SuperAdminLayout from '@/components/superadmin/SuperAdminLayout';
import SuperAdminProfileTab from '@/components/superadmin/SuperAdminProfileTab';
import { useSuperAdminSettings } from '@/hooks/useSuperAdminSettings';

const SuperAdminProfile = () => {
  const { 
    isLoading,
    user,
    handleLogout
  } = useSuperAdminSettings();

  return (
    <SuperAdminLayout
      isLoading={isLoading}
      onLogout={handleLogout}
      userRole={user?.role}
      activeTab="profile"
    >
      <div className="container mx-auto py-6 px-4">
        <h1 className="text-2xl font-bold mb-6">Super Admin Profile</h1>
        <SuperAdminProfileTab />
      </div>
    </SuperAdminLayout>
  );
};

export default SuperAdminProfile;
